interface AiSummaryFooterProps {
  children: React.ReactNode;
}

export const AiSummaryFooter = ({ children }: AiSummaryFooterProps) => (
  <div className="border-primary flex border-t pt-4">{children}</div>
);
